










































































































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { GEnum } from '@/constants/enum.defination';
import { Component, Vue } from 'vue-property-decorator';
import { email, required, sameAs } from 'vuelidate/lib/validators';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import { Teacher } from '@/models/teacher/teacher';
import { StringUtils } from '@/utils/string.utils';
import { GradeSchoolClass, SchoolClassSelection } from '@/models/school-class/school-class';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import { teacherModule } from '@/store/modules/entities/teacher.module';
import GVTag from '@/components/GVTag.vue';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import GSchoolClassCheckBoxes from '@/components/GSchoolClassCheckboxes.vue';

@Component({
  name: 'GTeacherRegistration',
  components: {
    GSchoolClassCheckBoxes,
    GTitleBar,
    GCustomBreadCrumb,
    GVTag,
  },
  methods: {},
  validations: {
    teacher: {
      lastName: { required },
      firstName: { required },
      email: { required, email },
      password: { required },
      confirmPassword: { required, sameAsPassword: sameAs('password') },
    },
  },
})
export default class GTeacherRegistration extends mixins(GPageBase) {
  breadCrumbItems: BreadCrumbElement[] = [];
  isSelectedSchoolClass: boolean = false;

  async mounted() {
    this.breadCrumbItems = [
      { title: this.$t('HOME').toString(), icon: 'ios-home', routerPath: '/pages/home' },
      { title: this.$t('TEACHER_MANAGEMENT').toString(), icon: 'ios-school', routerPath: '/pages/teachers' },
      { title: this.$t('COMMON.REGISTRATION', { value: this.$t('TEACHER').toString() }).toString() },
    ];

    teacherModule.clearTeacher();
    await schoolClassModule.fetchGradesSchoolClasses();
    teacherModule.initSelectionSchoolClass(this.gradeSchoolClasses);
  }

  get gradeSchoolClasses(): GradeSchoolClass[] {
    return schoolClassModule.gradeSchoolClasses;
  }

  get teacher(): Teacher {
    return teacherModule.teacher;
  }

  get selectionSchoolClasses(): SchoolClassSelection[] {
    return teacherModule.selectionSchoolClass;
  }

  get isLastNameRequired(): boolean {
    return this.$v.teacher.lastName.$dirty && !this.$v.teacher.lastName.required;
  }

  get isFirstNameRequired(): boolean {
    return this.$v.teacher.firstName.$dirty && !this.$v.teacher.firstName.required;
  }

  get isEmailRequired(): boolean {
    return this.$v.teacher.email.$dirty && !this.$v.teacher.email.required;
  }

  get isNotValidEmail() {
    return this.$v.teacher.email.$error && !this.$v.teacher.email.email;
  }

  get isPasswordRequired(): boolean {
    return this.$v.teacher.password.$dirty && !this.$v.teacher.password.required;
  }

  get isPasswordOutOfRange(): boolean {
    return this.$v.teacher.password.$dirty && this.$v.teacher.password.$invalid == false && StringUtils.isValidPassword(this.teacher.password) == false;
  }

  get isConfirmPasswordSame(): boolean {
    return this.$v.teacher.confirmPassword.$dirty && !this.$v.teacher.confirmPassword.sameAsPassword;
  }

  get hasValidInput() {
    return !this.isLastNameRequired && !this.isFirstNameRequired && !this.isEmailRequired && !this.isNotValidEmail && !this.isPasswordRequired && !this.isConfirmPasswordSame;
  }

  get hasRequiredInputs() {
    return this.teacher.lastName.length > 0 && this.teacher.firstName.length > 0 && this.teacher.email.length > 0 && this.teacher.password.length > 0 && this.teacher.confirmPassword.length > 0;
  }

  get roleAdmin(): GEnum.Role {
    return GEnum.Role.Admin;
  }

  get roleNormal(): GEnum.Role {
    return GEnum.Role.Normal;
  }

  makeFormTouched() {
    this.$v.teacher.lastName.$touch();
    this.$v.teacher.firstName.$touch();
    this.$v.teacher.email.$touch();
    this.$v.teacher.password.$touch();
    this.$v.teacher.confirmPassword.$touch();
  }

  handleTeacherRegistrationSubmit() {
    this.makeFormTouched();
    if (!this.hasValidInput || !this.hasRequiredInputs || (this.teacher.role === this.roleNormal && !this.isSelectedSchoolClass)) {
      return;
    }
    teacherModule.addTeacherDetail().then((teacher: Teacher) => {
      this.showInsertSuccessed();
      this.$router.replace(`/pages/teachers`);
    });
  }

  handleSelectionSchoolClass(selectionSchoolClass: SchoolClassSelection[]) {
    teacherModule.setSelectionSchoolClass(selectionSchoolClass);
    this.isSelectedSchoolClass = selectionSchoolClass.some((schoolClassByGrade: SchoolClassSelection) => {
      return schoolClassByGrade.isChecked();
    });
  }
}
